import { render, staticRenderFns } from "./ui-input-time.vue?vue&type=template&id=2e9c18e7&"
import script from "./ui-input-time.vue?vue&type=script&lang=ts&"
export * from "./ui-input-time.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports